import { useState, useRef, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import { p as positionDefault } from '../reach-popover.esm-c19739dd.js';
import { useWindowSize } from './useWindowSize.js';
import 'react-dom';

const positionDefaultMobile = (targetRect, popoverRect) => {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    position: "fixed",
    right: 0,
    left: 0,
    bottom: 0
  };
};
const getPositionFn = (isMobile, position) => {
  if (position && !isMobile) {
    return position;
  } else if (position && isMobile) {
    return positionDefaultMobile;
  } else if (isMobile) {
    return positionDefaultMobile;
  } else {
    return positionDefault;
  }
};
const getIsMobile = (width, breakpoint) => width ? width <= breakpoint : false;
function useAutoPosition(_ref) {
  let {
    position,
    mobile = "auto"
  } = _ref;
  const size = useWindowSize();
  const {
    breakpoints
  } = useTheme();
  const mobileBreakpoint = typeof breakpoints[0] === "string" ? breakpoints[0].includes("px") ? parseInt(breakpoints[0].replace("px", ""), 10) : parseInt(breakpoints[0].replace("rem", ""), 10) * 16 : breakpoints[0];
  const [isMobile, setIsMobile] = useState(mobile === "auto" ? getIsMobile(size.width, mobileBreakpoint) : mobile);
  const positionFn = useRef(getPositionFn(isMobile, position));
  useEffect(() => {
    const newIsMobile = mobile !== "auto" ? mobile : getIsMobile(size.width, mobileBreakpoint);
    setIsMobile(newIsMobile);
    positionFn.current = getPositionFn(newIsMobile, position);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size, position, mobile]);
  return [isMobile, positionFn.current];
}

export { positionDefaultMobile, useAutoPosition };
